"use client";

import { MotionDiv, useInView } from "@/lib/framer";
import { Image } from "@/components/image";
import { useRef } from "react";

export default function TestimonialSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });

  return (
    <div className="mb-24 px-6 lg:px-8">
      <MotionDiv
        ref={ref}
        initial={{ opacity: 0, y: 40 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
        transition={{ duration: 0.6 }}
        className="mx-auto max-w-6xl columns-1 gap-6 space-y-6 md:columns-2 lg:columns-3"
      >
        <div className="border-border bg-card shadow-golden-200/50 border-golden-200/50 flex break-inside-avoid flex-col gap-4 rounded-lg border px-6 py-10 shadow-lg">
          <blockquote className="text-foreground text-lg leading-relaxed font-medium sm:text-xl">
            "Git Digest makes it easy to stay up-to-date on everything important that&apos;s happening with your code."
          </blockquote>
          <div className="mt-auto flex items-center gap-4">
            <div className="flex-shrink-0">
              <Image
                src="/images/static/gumroad-logo-symbol.svg"
                alt="Gumroad"
                width={40}
                height={40}
                className="overflow-visible rounded-full object-contain"
              />
            </div>
            <div>
              <div className="text-foreground text-base font-semibold">Sahil Lavingia</div>
              <div className="text-muted-foreground text-sm">Founder of Gumroad</div>
            </div>
          </div>
        </div>
        <div className="border-border bg-card shadow-golden-200/50 border-golden-200/50 flex break-inside-avoid flex-col gap-4 rounded-lg border px-6 py-10 shadow-lg">
          <blockquote className="text-foreground text-lg leading-relaxed font-medium sm:text-xl">
            "I set the digest to send to our Slack channel at 7am everyday. It&apos;s been very helpful to get us up and
            running with the day. Some days I focused more on one repo and I&apos;d miss what&apos;s happening in the
            other repo. So Git Digest is really useful here. It keeps the ball rolling! That&apos;s all. Nothing else.
            Set up once and enjoy. Write your commits like usual, without &apos;use ai to generate commit message&apos;
            thingy."
          </blockquote>
          <div className="mt-auto flex items-center gap-4">
            <div className="flex-shrink-0">
              <Image
                src="/images/static/klu-logo.png"
                alt="Klu"
                width={40}
                height={40}
                className="overflow-visible rounded-full bg-white object-contain"
              />
            </div>
            <div>
              <div className="text-foreground text-base font-semibold">Wildan Zulfikar</div>
              <div className="text-muted-foreground text-sm">Co-founder @ Klu</div>
            </div>
          </div>
        </div>
        <div className="border-border bg-card shadow-golden-200/50 border-golden-200/50 flex break-inside-avoid flex-col gap-4 rounded-lg border px-6 py-10 shadow-lg">
          <blockquote className="text-foreground text-lg leading-relaxed font-medium sm:text-xl">
            "Git Digest has been game changing for us. It keeps our developers honest and everybody sees exactly what
            everyone else is working on. It helps our PM a lot too to easily keep track of everybody&apos;s progress."
          </blockquote>
          <div className="mt-auto flex items-center gap-4">
            <div className="flex-shrink-0">
              <Image
                src="/images/static/gemnote-logo.png"
                alt="Gemnote"
                width={40}
                height={40}
                className="overflow-visible rounded-full border border-gray-200 bg-white object-contain p-2"
              />
            </div>
            <div>
              <div className="text-foreground text-base font-semibold">Anson Tsui</div>
              <div className="text-muted-foreground text-sm">CTO&nbsp;@&nbsp;Gemnote</div>
            </div>
          </div>
        </div>
      </MotionDiv>
    </div>
  );
}
